import { useState, useCallback } from 'react';
import { X, ZoomIn } from 'lucide-react';
import { createPortal } from 'react-dom';

interface ImageLightboxProps {
  src: string;
  fullSrc?: string;
  alt: string;
  className?: string;
  eager?: boolean;
}

export function ImageLightbox({ src, fullSrc, alt, className, eager }: ImageLightboxProps) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <>
      <div className="relative group cursor-pointer" onClick={open}>
        <img
          src={src}
          alt={alt}
          className={`transition-opacity hover:opacity-90 ${className || ''}`}
          loading={eager ? "eager" : "lazy"}
          decoding={eager ? "sync" : "async"}
          {...(eager ? { fetchPriority: "high" as const } : {})}
        />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/20 rounded-lg">
          <div className="bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-lg">
            <ZoomIn className="h-5 w-5 text-[#1A1F3C]" />
          </div>
        </div>
      </div>
      {isOpen &&
        createPortal(
          <div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
            onClick={close}
          >
            <button
              onClick={close}
              className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors z-10"
              aria-label="Close"
            >
              <X className="h-8 w-8" />
            </button>
            <img
              src={fullSrc || src}
              alt={alt}
              className="max-w-full max-h-[90vh] rounded-lg shadow-2xl object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>,
          document.body
        )}
    </>
  );
}
